// Code generated by Slice Machine. DO NOT EDIT.
import HeroBannerV2 from "./HeroBannerV2";
import MemberProgramV2 from "./MemberProgramV2";
import ProductCatalogueV2 from "./ProductCatalogueV2";
import HtmlSectionV2 from "./HtmlSectionV2";
import TextBlockV2 from "./TextBlockV2";
import ButtonGalleryV2 from "./ButtonGalleryV2";
import MediaGridV2 from "./MediaGridV2";
import CardMediaGridV2 from './CardMediaGridV2';
import WorkWithUs from './WorkWithUs';
import CampaignBannerV2 from './CampaignBannerV2';
import BundleProductsV2 from './BundleProductsV2';
import ImageSectionV2 from './ImageSectionV2';
import NewsSubscriptionV2 from './NewsSubscriptionV2';
import ListOfArticlesV2 from './ListOfArticlesV2';
import CallToActionV2 from './CallToActionV2';
import TopCategoryV2 from './TopCategoryV2';
import CustomerReviewV2 from './CustomerReviewV2';
import InstagramV2 from './InstagramV2';
import HeroCarouselV2 from './HeroCarouselV2';
import ShopByStyleV2 from './ShopByStyleV2';
import ShopByOfferV2 from './ShopByOfferV2';


export const components = {
HeroBannerV2,
MemberProgramV2,
ProductCatalogueV2,
HtmlSectionV2,
TextBlockV2,
ButtonGalleryV2,
MediaGridV2,
CardMediaGridV2,
WorkWithUs,
CampaignBannerV2,
bundle_products_v2: BundleProductsV2,
image_section_v2: ImageSectionV2,
news_subscription_v2: NewsSubscriptionV2,
list_of_articles_v2: ListOfArticlesV2,
call_to_action_v2: CallToActionV2,
top_category_v2: TopCategoryV2,
customer_review_v2: CustomerReviewV2,
instagram_v2: InstagramV2,
hero_carousel_v2: HeroCarouselV2,
shop_by_style_v2: ShopByStyleV2,
shop_by_offer_v2 : ShopByOfferV2
};
